import { ParameterTypeConfig } from './formDataConfig';
import _ from 'lodash';
import { formatString } from '../../utils/helpers';

export const getField = (key: string, label: string) => {
  return {
    key: key,
    label: label,
    type: key === 'primary/secret' || key === 'provider_primary_secret' ? 'password' : 'text',
    size: 6,
    // required: true,
    placeholder: 'Enter' + label,
    disabled: true
    // rules: {
    //   required: {
    //     value: true,
    //     message: label + ' is Required'
    //   }
    // }
  };
};

export const getParameterLabel = (paramType: string) => {
  const parameterLabel = _.filter(ParameterTypeConfig || [], o => o.value === paramType);
  return parameterLabel[0].label;
};

export const replaceEmptyString = (obj: any) => {
  const str = JSON.stringify(obj, (key, val) => {
    return typeof val === 'string' && val != null && val.trim() === '' ? null : val;
  });
  return formatString(str);
};

export default getField;
